<script setup lang="ts">
import { h } from 'vue'
import {useCartStore} from "~~/stores/cart";
const localePath = useLocalePath()

const cart = useCartStore()

onMounted(() => {
    if (!cart.cart) cart.fetch().catch(() => {})
})

const IconCart = defineComponent({
    name: 'IconCart',
    inheritAttrs: false,
    setup(_, { attrs }) {
        return () =>
            h(
                'svg',
                { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 29 31', ...attrs },
                [
                    h('path', { fill: '#3D0703', d: 'M20.06 14.05C19.4 14.05 18.86 13.51 18.86 12.85V6.59C18.86 4.28 16.98 2.4 14.68 2.4C12.38 2.4 10.49 4.28 10.49 6.59V12.85C10.49 13.51 9.94997 14.05 9.28997 14.05C8.62997 14.05 8.08997 13.51 8.08997 12.85V6.59C8.08997 2.96 11.04 0 14.67 0C18.3 0 21.25 2.95 21.25 6.58V12.84C21.25 13.5 20.71 14.04 20.05 14.04L20.06 14.05Z' }),
                    h('path', { fill: '#3D0703', d: 'M22.66 30.36H14.68V27.96H22.66C23.33 27.96 23.9 27.48 23.98 26.84L26 11.47C26.05 11.11 25.94 10.76 25.7 10.49C25.45 10.2 25.07 10.03 24.68 10.03H4.68C4.28 10.03 3.91 10.2 3.66 10.49C3.42 10.77 3.31 11.11 3.36 11.47L5.38 26.84C5.46 27.48 6.03 27.96 6.7 27.96H14.68V30.36H6.7C4.83 30.36 3.24 28.98 3 27.15L0.979998 11.78C0.839998 10.74 1.16 9.7 1.86 8.91C2.57 8.1 3.6 7.64 4.69 7.64H24.69C25.78 7.64 26.81 8.1 27.51 8.91C28.2 9.7 28.52 10.75 28.39 11.79L26.37 27.16C26.13 28.99 24.54 30.37 22.67 30.37L22.66 30.36Z' }),
                ]
            )
    }
})

</script>

<template>
    <UIcon
        v-if="cart.count === 0"
        :name="IconCart"
        class="h-[24px] lg:h-[30px] w-auto"
    />
    <ULink v-else :to="localePath('kosarica')" class="relative">
        <UIcon :name="IconCart" class="h-[24px] lg:h-[30px] w-auto" />
        <div class="absolute -bottom-[5px] -right-[5px] w-[19px] h-[19px] bg-white rounded-[50%] border-2 border-[#f7948c]">
      <span
          class="cart-contents-quantity absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 text-[#CC4036] font-bold text-[14px]"
      >
        {{ cart.count }}
      </span>
        </div>
    </ULink>
</template>

<style scoped>
.cart-contents-quantity {
    font-family: "Quicksand", "sans-serif";
    font-weight: 700;
}
</style>
